import type { ViewModel } from '../../shared/viewmodel.ts';
import { LensPanel } from '../bench/Lens.tsx';
import { SelectionAction } from '../bench/SelectionAction.tsx';
import { lens, lensOpen } from '../bench/state.ts';
import { VirtualReader } from '../reader/VirtualReader.tsx';
import { LENS } from '../strings-bench.ts';
import { READER } from '../strings-reader.ts';

/**
 * The evidence map (UX-SPEC §6): the whole document with every channel's evidence spans. `reader.selection` and the
 * `reader.second-column` lens (UX-SPEC §17) wrap `VirtualReader` rather than joining its virtualised grid
 * (BENCH-UX-SPEC §3): the lens is a side panel, toggled here, and the selection action is a plain listener.
 */
export function Reader({ vm }: { vm: ViewModel }) {
	const l = lens.value;
	const mine = l !== null && l.docHash === (vm.meta.version?.root ?? vm.meta.docHash);
	if (vm.paras.count === 0)
		return (
			<div class="rd">
				<h1 class="visually-hidden">{READER.title}</h1>
				<p class="dim">{READER.empty}</p>
			</div>
		);
	return (
		<div class={`rd-with-lens${mine && lensOpen.value ? ' has-lens' : ''}`}>
			<div class="rd-col">
				<VirtualReader vm={vm} key={vm.meta.docHash} />
				<SelectionAction />
			</div>
			{mine ? (
				lensOpen.value ? (
					<LensPanel />
				) : (
					<button
						type="button"
						class="btn btn-secondary lens-toggle bench-desktop-only"
						onClick={() => {
							lensOpen.value = true;
						}}
					>
						{LENS.open}
					</button>
				)
			) : null}
		</div>
	);
}
